import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { CreateRealEstateForm } from "web_myplann/Portfolio/Pages/RealEstateCreate/CreateRealEstateForm";
import { PortfolioAddLayout } from "web_myplann/Portfolio/PortfolioShared/PortfolioAddLayout";

export const AddRealEstatePage = () => {
	const { t } = useResource();

	return (
		<PortfolioAddLayout title={t(Resources.Portfolio.AddRealEstate.title)}>
			<CreateRealEstateForm />
		</PortfolioAddLayout>
	);
};
